module.exports = __webpack_public_path__ + "4706a48957995774617f321016b2ee63.png";